import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { API_PRECOG_URL_V1 } from "../../../config";

export const precogConstants = {
  GET_INVOICES_LIST_START: "GET_INVOICES_LIST_START",
  GET_INVOICES_LIST_SUCCESS: "GET_INVOICES_LIST_SUCCESS",
  GET_INVOICES_LIST_ERROR: "GET_INVOICES_LIST_ERROR",

  GET_INVOICE_DETAIL_START: "GET_INVOICE_DETAIL_START",
  GET_INVOICE_DETAIL_SUCCESS: "GET_INVOICE_DETAIL_SUCCESS",
  GET_INVOICE_DETAIL_ERROR: "GET_INVOICE_DETAIL_ERROR",

  GET_DETAIL_ACCOUNTS_START: "GET_DETAIL_ACCOUNTS_START",
  GET_DETAIL_ACCOUNTS_SUCCESS: "GET_DETAIL_ACCOUNTS_SUCCESS",
  GET_DETAIL_ACCOUNTS_ERROR: "GET_DETAIL_ACCOUNTS_ERROR",
  CLEAR_DETAIL_ACCOUNTS: "CLEAR_DETAIL_ACCOUNTS",
  CLEAR_DETAIL_ACCOUNTINGS_ACCOUNTS: "CLEAR_DETAIL_ACCOUNTINGS_ACCOUNTS",

  GET_SEARCH_ACCOUNTS_START: "GET_SEARCH_ACCOUNTS_START",
  GET_SEARCH_ACCOUNTS_SUCCESS: "GET_SEARCH_ACCOUNTS_SUCCESS",
  GET_SEARCH_ACCOUNTS_ERROR: "GET_SEARCH_ACCOUNTS_ERROR",

  CLEAR_SEARCHED_ACCOUNTS: "CLEAR_SEARCHED_ACCOUNTS",

  CLEAR_SEARCHED_REASONS_CLASSIFIED: "CLEAR_SEARCHED_REASONS_CLASSIFIED",

  CLEAR_INVOICE_DETAIL: "CLEAR_INVOICE_DETAIL",

  CONFIRM_INVOICE_START: "CONFIRM_INVOICE_START",
  CONFIRM_INVOICE_SUCCESS: "CONFIRM_INVOICE_SUCCESS",
  CONFIRM_INVOICE_ERROR: "CONFIRM_INVOICE_ERROR",

  GET_REASONS_START: "GET_REASONS_START",
  GET_REASONS_SUCCESS: "GET_REASONS_SUCCESS",
  GET_REASONS_ERROR: "GET_REASONS_ERROR",

  GET_REASONS_CLASSIFIED_START: "GET_REASONS_CLASSIFIED_START",
  GET_REASONS_CLASSIFIED_SUCCESS: "GET_REASONS_CLASSIFIED_SUCCESS",
  GET_REASONS_CLASSIFIED_ERROR: "GET_REASONS_CLASSIFIED_ERROR",

  GET_UPDATED_DETAIL_START: "GET_UPDATED_DETAIL_START",
  GET_UPDATED_DETAIL_SUCCESS: "GET_UPDATED_DETAIL_SUCCESS",
  GET_UPDATED_DETAIL_ERROR: "GET_UPDATED_DETAIL_ERROR",

  CREATE_NEW_INVOICE_START: "CREATE_NEW_INVOICE_START",
  CREATE_NEW_INVOICE_SUCCESS: "CREATE_NEW_INVOICE_SUCCESS",
  CREATE_NEW_INVOICE_ERROR: "CREATE_NEW_INVOICE_ERROR",

  GET_WITHHOLDINGS_START: "GET_WITHHOLDINGS_START",
  GET_WITHHOLDINGS_SUCCESS: "GET_WITHHOLDINGS_SUCCESS",
  GET_WITHHOLDINGS_ERROR: "GET_WITHHOLDINGS_ERROR",

  GET_ACTIVITIES_START: "GET_ACTIVITIES_START",
  GET_ACTIVITIES_SUCCESS: "GET_ACTIVITIES_SUCCESS",
  GET_ACTIVITIES_ERROR: "GET_ACTIVITIES_ERROR",

  POST_REGISTRATION_SINGLE_START: "POST_REGISTRATION_SINGLE_START",
  POST_REGISTRATION_SINGLE_SUCCESS: "POST_REGISTRATION_SINGLE_SUCCESS",
  POST_REGISTRATION_SINGLE_ERROR: "POST_REGISTRATION_SINGLE_ERROR",

  POST_REGISTRATION_MULTIPLE_START: "POST_REGISTRATION_MULTIPLE_START",
  POST_REGISTRATION_MULTIPLE_SUCCESS: "POST_REGISTRATION_MULTIPLE_SUCCESS",
  POST_REGISTRATION_MULTIPLE_ERROR: "POST_REGISTRATION_MULTIPLE_ERROR",

  UPDATE_REGIME_START: "UPDATE_REGIME_START",
  UPDATE_REGIME_SUCCESS: "UPDATE_REGIME_SUCCESS",
  UPDATE_REGIME_ERROR: "UPDATE_REGIME_ERROR",

  UPDATE_REASON_START: "UPDATE_REASON_START",
  UPDATE_REASON_SUCCESS: "UPDATE_REASON_SUCCESS",
  UPDATE_REASON_ERROR: "UPDATE_REASON_ERROR",
  
  GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_START: "GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_START",
  GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_SUCCESS: "GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_SUCCESS",
  GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_ERROR: "GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_ERROR",

  DELETE_DRAFT_START: "DELETE_DRAFT_START",
  DELETE_DRAFT_SUCCESS: "DELETE_DRAFT_SUCCESS",
  DELETE_DRAFT_ERROR: "DELETE_DRAFT_ERROR",
  getDraftIdFromOriginalEntry
};

export function getInvoicesList(confirmed, filters) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = `${API_PRECOG_URL_V1}/precog/drafts?`;
    if (filters) {
      url = url + `filterBy=${filters}&confirmed=${confirmed}&itemId=${itemId}&managerId=${managerId}`;
    } else {
      url = url + `confirmed=${confirmed}&itemId=${itemId}&managerId=${managerId}`;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_INVOICES_LIST_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_INVOICES_LIST_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.GET_INVOICES_LIST_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_INVOICES_LIST_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getInvoiceDetail(invoiceId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${invoiceId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_INVOICE_DETAIL_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_INVOICE_DETAIL_SUCCESS,
              payload: result
              // rates: store.getState().precog.vat.rates.list
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.GET_INVOICE_DETAIL_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_INVOICE_DETAIL_START,
            error: response
          });
          reject();
        });
    });
  };
}

export function getAccountingRelationAssetsAccounts(accountCode) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;   
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",                
        url: `${API_PRECOG_URL_V1}/accounting/relations/assets/accounts/?itemId=${itemId}&managerId=${managerId}&accountCode=${accountCode}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {                 
            resolve(result.data?.relatedAccountsDetails);
          } else {            
            reject();
          }
        })
        .catch((response) => {         
          reject(response);
        });
    });
  };
}

export function getDetailAccounts(invoiceId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${invoiceId}/accountingLines?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_DETAIL_ACCOUNTS_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_DETAIL_ACCOUNTS_SUCCESS,
              payload: result
              // rates: store.getState().precog.vat.rates.list
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.GET_DETAIL_ACCOUNTS_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_DETAIL_ACCOUNTS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function clearDetailAccounts() {
  return (dispatch) => {
    dispatch({
      type: precogConstants.CLEAR_DETAIL_ACCOUNTS
    });
  };
}

export function searchAccounts(
  searchText, limit = 10, includeSystem=false, onlyConfirmed = null
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    /*
    const precog = getState().precog;
    
    const source = precog?.invoiceDetail?.data?.source;
    
    let includeSystemValue = ["MANUAL", "DOC"].includes(source);
    if (includeSystem)
      includeSystemValue = true;
    */
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/accounting/accounts?itemId=${itemId}&managerId=${managerId}&search=${searchText ? searchText : ""}&limit=${limit}&includeSystem=${includeSystem}${onlyConfirmed ? "&onlyConfirmed=" + onlyConfirmed : ""}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_SEARCH_ACCOUNTS_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_SEARCH_ACCOUNTS_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.GET_SEARCH_ACCOUNTS_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_SEARCH_ACCOUNTS_START,
            error: response
          });
          reject();
        });
    });
  };
}

export function clearSearched() {
  return (dispatch) => {
    dispatch({
      type: precogConstants.CLEAR_SEARCHED_ACCOUNTS
    });
  };
}

export function clearAccountingLines() {
  return (dispatch) => {
    dispatch({
      type: precogConstants.CLEAR_DETAIL_ACCOUNTINGS_ACCOUNTS
    });
  };
}

export function clearSearchedReasonsClassified() {
  return (dispatch) => {
    dispatch({
      type: precogConstants.CLEAR_SEARCHED_REASONS_CLASSIFIED
    });
  };
}

export function clearInvoiceDetail() {
  return (dispatch) => {
    dispatch({
      type: precogConstants.CLEAR_INVOICE_DETAIL
    });
  };
}

export function confirmInvoice(id) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${id}/confirm?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {}
      };

      dispatch({
        type: precogConstants.CONFIRM_INVOICE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.CONFIRM_INVOICE_SUCCESS,
              payload: result
            });
            dispatch({
              type: "REMOVE_FROM_DRAFT_LIST",
              payload: id
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.CONFIRM_INVOICE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.CONFIRM_INVOICE_START,
            error: response
          });
          reject();
        });
    });
  };
}

export function getReasons(factType, saleOrPurchse) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = `${API_PRECOG_URL_V1}/precog/reasons?itemId=${itemId}&managerId=${managerId}&classification=${factType ? factType : ["INVOICE", "BANK_TRANSACTION", "RECEIPT"]}`;
    if (factType && saleOrPurchse) {
      url = `${url}&type=${saleOrPurchse}`;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_REASONS_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_REASONS_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.GET_REASONS_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_REASONS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getReasonsClassified(
  classification, textSearch, type
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/reasons?itemId=${itemId}&managerId=${managerId}&classification=${classification}${
          textSearch ? "&fullTextSearch=" + textSearch : ""
        }&type=${type}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_REASONS_CLASSIFIED_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_REASONS_CLASSIFIED_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: precogConstants.GET_REASONS_CLASSIFIED_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_REASONS_CLASSIFIED_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function updatedDetail(draftId, newDetail) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: newDetail
      };

      dispatch({
        type: precogConstants.GET_UPDATED_DETAIL_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_UPDATED_DETAIL_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.GET_UPDATED_DETAIL_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_UPDATED_DETAIL_ERROR,
            error: JSON.parse(JSON.stringify(response))?.response?.data?.message
          });
          reject(JSON.parse(JSON.stringify(response))?.response?.data?.message);
        });
    });
  };
}

export function createNewInvoice(detailToSave) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: detailToSave
      };

      dispatch({
        type: precogConstants.CREATE_NEW_INVOICE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.CREATE_NEW_INVOICE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.CREATE_NEW_INVOICE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.CREATE_NEW_INVOICE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getWithHolding(reasonId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let url = reasonId
        ? `${API_PRECOG_URL_V1}/withholding/reasons?itemId=${itemId}&managerId=${managerId}&cuReason=${reasonId}`
        : `${API_PRECOG_URL_V1}/withholding/reasons?itemId=${itemId}&managerId=${managerId}`;
      let request = {
        method: "GET",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_WITHHOLDINGS_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_WITHHOLDINGS_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.GET_WITHHOLDINGS_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_WITHHOLDINGS_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getActivities() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/workspace/businesses-flat?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.GET_ACTIVITIES_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.GET_ACTIVITIES_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.GET_ACTIVITIES_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.GET_ACTIVITIES_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function postRegistrationSingle(registrationId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${registrationId}/confirm?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: precogConstants.POST_REGISTRATION_SINGLE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.POST_REGISTRATION_SINGLE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.POST_REGISTRATION_SINGLE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.POST_REGISTRATION_SINGLE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function postRegistrationMultiple(draftsList) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/confirm-multiple?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: {
          draftIdList: [...draftsList]
        }
      };

      dispatch({
        type: precogConstants.POST_REGISTRATION_MULTIPLE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.POST_REGISTRATION_MULTIPLE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.POST_REGISTRATION_MULTIPLE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.POST_REGISTRATION_MULTIPLE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function updateRegime(draftId, regime) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/update-regime?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: regime
      };

      dispatch({
        type: precogConstants.UPDATE_REGIME_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: precogConstants.UPDATE_REGIME_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: precogConstants.UPDATE_REGIME_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: precogConstants.UPDATE_REGIME_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getDraftIdFromOriginalEntry(originalEntryId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/original-entry-id/${originalEntryId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };
      dispatch({
        type: precogConstants.GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_START,
        request
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {  
            dispatch({
              type: precogConstants.GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_SUCCESS,
              payload: result
            });          
            resolve(result.data);
          } else {    
            dispatch({
              type: precogConstants.GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_ERROR,
              error: result
            });       
            reject();
          }
        })
        .catch((response) => {   
          dispatch({
            type: precogConstants.GET_DRAFT_ID_FROM_ORIGINAL_ENTRY_ERROR,
            error: response
          });             
          reject(response);
        });
    });
  };
}

export function deleteDraft(draftId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      const request = {
        method: "DELETE",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };      
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {          
          dispatch({
            type: precogConstants.DELETE_DRAFT_SUCCESS,
            payload: draftId
          });
          resolve(result.data);         
        })
        .catch((response) => {
          
          dispatch({
            type: precogConstants.DELETE_DRAFT_ERROR,
            error: response?.response?.data?.message || "Si è verificato un errore"
          });
          reject(response?.response?.data?.message || "Si è verificato un errore");
        });
    });
  };
}
